(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('filterValue', filterValue);

    function filterValue() {
        return {
            restrict: 'EA',
            scope: {
                filter: '='
            },
            controller: filterValueCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/components/filter-value'
        };
    }

    function filterValueCtrl($scope, lodash) {
        var vm = this;
        this.$onInit = function() {
            $scope.listFilterService = $scope.$parent.listFilterService;
            vm.pageData = {};

            vm.settingsOverride = $scope.listFilterService.getFilterService().getFilterOptionInputConfig(lodash.get(vm, 'filter.type', ''));

            $scope.$watch(watchFilter, onFilterChange);
            init();
        }

        function init() {
            $scope.listFilterService.sync(vm);
        }

        function watchFilter() {
            return vm.filter;
        }

        function onFilterChange() {
            if (vm.filter) {
                $scope.listFilterService.getFilterService().prepareFilterOptionValues();
            }
        }
    }
})();